export enum EntityState {
  NotChanged = "NotChanged",
  Add = "Add",
  Delete = "Delete",
  Update = "Update",
}
